import { useLang } from "@/context/LanguageContext";
import { LogoImg } from "@/components/Logo";
import { products } from "@/data/products";
import { LEGAL_DOCS, LEGAL_CONTENT } from "@/data/legal";
import { clearMarketingConsent } from "@/utils/metaPixel";

export const Footer = () => {
    const { lang, t } = useLang();

    return (
        <footer data-testid="footer" className="border-t border-stone-200 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                    <div className="flex flex-col gap-2">
                        <LogoImg className="h-9 w-auto" />
                        <p className="text-[11px] text-stone-500">{t("footer.tagline")}</p>
                    </div>
                    <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-stone-600">
                        {products.map((p) => (
                            <a
                                key={p.id}
                                href={`/regalo/${p.handle}`}
                                className="hover:text-bordeaux transition-colors"
                            >
                                {p.name[lang]}
                            </a>
                        ))}
                    </nav>
                </div>
                <div className="mt-8 pt-6 border-t border-stone-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
                    <p className="text-[11px] text-stone-400">
                        © {new Date().getFullYear()} Amor Sin Aviso · {t("footer.rights")}
                    </p>
                    <p className="text-[11px] text-stone-400 italic">{t("footer.demoNote")}</p>
                </div>
                <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-[12px] text-stone-500 border-t border-stone-100 pt-4">
                    {LEGAL_DOCS.map((d) => (
                        <a
                            key={d.slug}
                            href={`/legal/${d.slug}`}
                            data-testid={`legal-link-${d.slug}`}
                            className="hover:text-bordeaux transition-colors"
                        >
                            {LEGAL_CONTENT[d.key][lang].title}
                        </a>
                    ))}
                    <button
                        data-testid="footer-cookies-reset"
                        onClick={() => {
                            clearMarketingConsent();
                            window.location.reload();
                        }}
                        className="hover:text-bordeaux transition-colors"
                    >
                        Cookies
                    </button>
                </div>
            </div>
        </footer>
    );
};
